import axios from "axios";
import { GET_ALL_NOTIFICATION } from "./types";

const PROXY = process.env.REACT_APP_URL + "api/";

// Get Notification
export const getNotification = (page) => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}notification/user/all?page=${page}`);
    dispatch({
      type: GET_ALL_NOTIFICATION,
      payload: res.data.result,
    });
  } catch (err) {
    console.error(err);
    //   toast.error(err.response.data.message);
  }
};
